window.addEventListener('DOMContentLoaded', function() {
  /*if (window.location.href.includes("product")) {
  var observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "characterData" ||
        (mutation.type === "childList" && mutation.addedNodes.length > 0)
      ) {
        const button = document.querySelector(".m-sticky-addtocart .m-add-to-cart .m-add-to-cart--text");
        if (button && button.textContent !== "Buy Now & Save Up to 50%") {
          button.textContent = "Buy Now & Save Up to 50%";
        }
      }
    });
  });
  const config = {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  };
  const target = document.querySelector(".m-sticky-addtocart .m-add-to-cart .m-add-to-cart--text");
  if (target) observer.observe(target, config);
}*/
/* какой неадекватный человек написал этот код? */

// -----------
function updateMarginTop() {
  var countdownbanner = document.querySelector('#countdown-banner')
  var announcementBar = document.querySelector('.m-announcement-bar')
  var headerInner = document.querySelector('.m-header__wrapper')
  var mainContent = document.getElementById('MainContent')

  var announcementBarHeight = announcementBar ? announcementBar.clientHeight : 0
  var countdownbannerHeight = countdownbanner ? countdownbanner.clientHeight : 0

  var headerInnerHeight = headerInner ? headerInner.clientHeight : 0

  // var totalHeight = announcementBarHeight + headerInnerHeight;
  var totalHeight = headerInner.classList.contains('transparent-on-top') ? announcementBarHeight : announcementBarHeight + headerInnerHeight + countdownbannerHeight

  mainContent.style.marginTop = totalHeight + 'px'
}
        // Initial call to set the margin top on page load
        updateMarginTop();

        // Set aspect ratio on page load
        document.addEventListener('DOMContentLoaded', function() {
            updateMarginTop();
        });


        // Recalculate on window resize
        window.addEventListener('resize', updateMarginTop);


// --------------

       function setAspectRatio() {
            var customImage = document.querySelector('.m-custom-image-with-text');
            if (customImage) {
                var responsiveImage = customImage.querySelector('responsive-image');
                if (responsiveImage) {
                    var aspectRatio = window.innerWidth > 768 ? 1 : 0.6809090909090909;
                    responsiveImage.style.setProperty('--aspect-ratio', aspectRatio);
                }
            }
        }

        function onWindowResize() {
            setAspectRatio();
        }

        // Set aspect ratio on page load
        document.addEventListener('DOMContentLoaded', function() {
            setAspectRatio();
        });

        // Set aspect ratio on window resize
        window.addEventListener('resize', onWindowResize);

// ---------------

// document.addEventListener("DOMContentLoaded", function() {
//     // Находим элементы по классу и id
//     var productInfoWrapper = document.querySelector('.m-product-info--wrapper');
//     var productDetailsTabs = document.getElementById('shopify-section-template--16227965927575__product-details-tabs');

//     // Проверяем, что оба элемента существуют
//     if (productInfoWrapper && productDetailsTabs) {
//         // Вырезаем секцию по id
//         var extractedSection = productDetailsTabs.parentNode.removeChild(productDetailsTabs);

//         // Переносим вырезанную секцию в конец элемента с классом m-product-info--wrapper
//         productInfoWrapper.appendChild(extractedSection);
//     }
// });


// =======================
function applyStylesToElement(element) {

    if (window.innerWidth < 768) {
      element.style.transform = 'scale(0.8) translateY(-33px)';
    } else {
      element.style.transform = 'scale(1)';
    }
}

function checkAndApplyStyles() {
  var targetElement = document.querySelector('span.needsclick.kl-private-reset-css-Xuajs1');

  if (targetElement) {
    applyStylesToElement(targetElement);
    clearInterval(checkInterval);
  }
}
var checkInterval = setInterval(checkAndApplyStyles, 1000); // каждую секунду
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(function(addedNode) {
        if (addedNode.tagName === 'SPAN' && addedNode.classList.contains('needsclick') && addedNode.classList.contains('kl-private-reset-css-Xuajs1')) {
          applyStylesToElement(addedNode);
          clearInterval(checkInterval);
        }
      });
    }
  });
});
var config = { childList: true, subtree: true };
observer.observe(document.body, config);
window.addEventListener('resize', function() {
  checkAndApplyStyles();
});
// ==========================

// Функція для застосування стилів до елемента в залежності від ширини вікна
function applyStylesToChatButton(element) {
  if (window.innerWidth < 768) {
    element.style.bottom = '78px';

     var topButton = document.getElementById('scroll-to-top-button');
     if(topButton){
       topButton.style.bottom = '150px';
      }
  } else {
    element.style.bottom = '16px';

    var topButton = document.getElementById('scroll-to-top-button');
     if(topButton){
       topButton.style.bottom = '86px';
      }
  }
}

// Функція для перевірки наявності елемента і застосування стилів
function checkAndApplyChatButtonStyles() {
  var chatButtonElement = document.getElementById('dummy-chat-button-iframe');

  if (chatButtonElement) {
    // Якщо елемент знайдено, застосовуємо стилі
    applyStylesToChatButton(chatButtonElement);
    clearInterval(checkChatButtonInterval);
  }
}

// Встановлюємо інтервал для перевірки наявності елемента
var checkChatButtonInterval = setInterval(checkAndApplyChatButtonStyles, 1000); // кожну секунду

// Створюємо Observer для відстеження додавання елемента в DOM
var chatButtonObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // Перевіряємо, чи мутація містить додавання вузла
    if (mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(function(addedNode) {
        // Якщо доданий вузол є цільовим елементом
        if (addedNode.id === 'dummy-chat-button-iframe') {
          // Застосовуємо стилі та очищаємо інтервал
          applyStylesToChatButton(addedNode);
          clearInterval(checkChatButtonInterval);
        }
      });
    }
  });
});

// Налаштовуємо параметри для відстеження додавання вузлів
var configChatButton = { childList: true, subtree: true };

// Запускаємо відстеження
chatButtonObserver.observe(document.body, configChatButton);

// Додаємо обробник події resize для зміни стилів при зміні ширини вікна
window.addEventListener('resize', function() {
  checkAndApplyChatButtonStyles();
});



  function updateGridColumnViews() {
    var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var gridColumnViews = screenWidth > 767 ? 3 : 2;
    if (typeof(Storage) !== "undefined") {
    localStorage.setItem('gridColumnViews', gridColumnViews);
  }
  var collectionProductsElement = document.querySelector('.m-collection-products');
  if (collectionProductsElement !== null) {
    var currentClass = collectionProductsElement.className;
    currentClass = currentClass.replace(/\bm-cols-\d\b/, '');
    currentClass += ' m-cols-' + gridColumnViews;
    collectionProductsElement.className = currentClass;
  }
  }
  updateGridColumnViews();
  window.addEventListener('resize', function() {
    updateGridColumnViews();
  });
})

class CopyButton extends HTMLElement {
  constructor() {
    super();

    this.popupMessage = this.dataset.popupText;
    this.popupClassName = this.dataset.popupClass;
    this.textToCopy = this.dataset.textCopy;
    this.parentPopup = this.dataset.parentPopup;

    this.popupElement = null;
  }

  connectedCallback() {
    if (!this.isClipboardSupported()) {
      return console.warn('CopyButton: Clipboard API is not supported in this environment.');
    }

    const parentPopupElement = document.querySelector(this.parentPopup);
    if (!parentPopupElement) {
      return console.warn('CopyButton: Parent popup not found.');
    }

    this.createPopup(parentPopupElement);

    this.addEventListener('click', () => {
      navigator.clipboard.writeText(this.textToCopy)
        .then(() => this.showPopup())
        .catch(err => console.error('CopyButton:', err));
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  isClipboardSupported() {
    return navigator.clipboard && window.isSecureContext;
  }

  createPopup(container) {
    const popup = document.createElement('div');
    popup.textContent = this.popupMessage;
    popup.className = this.popupClassName;

    container.appendChild(popup);
    this.popupElement = popup;
  }

  showPopup() {
    if (!this.popupElement) return;

    this.popupElement.classList.add('visible');

    setTimeout(() => {
      this.popupElement.classList.remove('visible');
    }, 2000);
  }
}

if (!customElements.get('copy-button')) {
  customElements.define('copy-button', CopyButton);
}
